import React, { useState } from 'react'
import DashboardLayout from '../../../../layouts/Dashboard'
import { Col, Row, Container } from 'react-bootstrap'
import { useParams } from 'react-router-dom'

import VehicleInfo from '../../../../components/Vehicle/VehicleInfo'
import VehicleAlerts from '../../../../components/Vehicle/VehicleAlerts'
import VehiclePerformance from '../../../../components/Vehicle/VehiclePerformance'
import VehicleHistorical from '../../../../components/Vehicle/VehicleHistorical'
import { PencilSimpleLine, X } from 'phosphor-react'

import 'react-date-picker/dist/DatePicker.css'
import 'react-calendar/dist/Calendar.css'
import styles from './styles.module.css'
import './styles.css'

import DatePicker from 'react-date-picker'

const VeiculosInfo: React.FC = () => {
  let { id } = useParams()

  const [alertMonth, setAlertMonth] = useState<any>({
    pickerDate: '',
    date: '',
  })
  const [performanceMonth, setPerformanceMonth] = useState<any>({
    pickerDate: '',
    date: '',
  })

  const [isPerformancePickerOpen, setIsPerformancePickerOpen] = useState(false)
  const [isAlertPickerOpen, setIsAlertPickerOpen] = useState(false)

  const handleAlertIconClick = () => {
    setIsAlertPickerOpen(!isAlertPickerOpen)
  }

  const handlePerformanceIconClick = () => {
    setIsPerformancePickerOpen(!isPerformancePickerOpen)
  }

  return (
    <DashboardLayout backgroundColor="#F8F8F8" pageName="Informações do veículo">
      <Container>
        <Row>
          <Col md={6}>
            <h3 className="mt-4 mb-3">Informações do veículo</h3>
            <span className="ml-5">
              <VehicleInfo vehicleId={id}></VehicleInfo>
            </span>
          </Col>

          <Col md={6}>
            <div className="d-flex flex-row align-items-center mt-4">
              <h3 style={{ marginLeft: '-2%', marginRight: 10 }} className="mb-0">
                Alertas
              </h3>
              <span className="mt-1 d-flex align-items-center">
                <span>
                  {alertMonth.date
                    ? new Date(alertMonth.date).toLocaleString('pt-BR', {
                        month: 'short',
                        year: 'numeric',
                        timeZone: 'UTC',
                      })
                    : 'Todo o período'}
                </span>
                <PencilSimpleLine
                  size={20}
                  color="#053C5E"
                  style={{ marginLeft: 5, cursor: 'pointer' }}
                  onClick={handleAlertIconClick}
                />
                {alertMonth.date && (
                  <X
                    size={20}
                    weight="bold"
                    color="#DB222A"
                    style={{ marginLeft: 5, cursor: 'pointer' }}
                    onClick={() => setAlertMonth({ pickerDate: '', date: '' })}
                  />
                )}

                <DatePicker
                  className={styles.datePicker}
                  value={alertMonth.pickerDate}
                  isOpen={isAlertPickerOpen}
                  maxDate={new Date()}
                  onChange={(value: any) =>
                    setAlertMonth({
                      pickerDate: value,
                      date: value.toISOString().substring(0, 7),
                    })
                  }
                  onBlur={() => setIsAlertPickerOpen(false)}
                  onCalendarClose={() => setIsAlertPickerOpen(false)}
                  calendarProps={{
                    defaultView: 'decade',
                    maxDetail: 'year',
                    minDetail: 'decade',
                  }}
                />
              </span>
            </div>
            <VehicleAlerts vehicleId={id} date={alertMonth.date}></VehicleAlerts>
          </Col>
        </Row>
        <Row>
          <Col md={6}>
            <h3 className="mt-4 mt-md-3 mb-3">Histórico do veículo</h3>
            <span className="ml-5">
              <VehicleHistorical vehicleId={id} role="company"></VehicleHistorical>
            </span>
          </Col>
          <Col md={6}>
            <div className="d-flex flex-row align-items-center mt-4">
              <h3 style={{ marginLeft: '-2%', marginRight: 10 }} className="mb-0">
                Desempenho
              </h3>
              <span className="mt-1 d-flex align-items-center">
                <span>
                  {performanceMonth.date
                    ? new Date(performanceMonth.date).toLocaleString('pt-BR', {
                        month: 'short',
                        year: 'numeric',
                        timeZone: 'UTC',
                      })
                    : 'Todo o período'}
                </span>
                <PencilSimpleLine
                  size={20}
                  color="#053C5E"
                  style={{ marginLeft: 5, cursor: 'pointer' }}
                  onClick={handlePerformanceIconClick}
                />

                {performanceMonth.date && (
                  <X
                    size={20}
                    weight="bold"
                    color="#DB222A"
                    style={{ marginLeft: 5, cursor: 'pointer' }}
                    onClick={() => setPerformanceMonth({ pickerDate: '', date: '' })}
                  />
                )}

                <DatePicker
                  className={styles.datePicker}
                  value={performanceMonth.pickerDate}
                  isOpen={isPerformancePickerOpen}
                  maxDate={new Date()}
                  onChange={(value: any) =>
                    setPerformanceMonth({
                      pickerDate: value,
                      date: value.toISOString().substring(0, 7),
                    })
                  }
                  onBlur={() => setIsPerformancePickerOpen(false)}
                  onCalendarClose={() => setIsPerformancePickerOpen(false)}
                  calendarProps={{
                    defaultView: 'decade',
                    maxDetail: 'year',
                    minDetail: 'decade',
                  }}
                />
              </span>
            </div>
            <VehiclePerformance vehicleId={id} date={performanceMonth.date}></VehiclePerformance>
          </Col>
        </Row>
      </Container>
    </DashboardLayout>
  )
}

export default VeiculosInfo
